import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=0089d982&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=0089d982&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089d982",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
